import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import { useSearchParams } from 'react-router-dom';
import { getVoteDetailsById } from '../../api/Vote';
import { getUser } from '../../api/auth';
import Sidebar from '../Sidebar/Sidebar';
import DashboardRightSection from '../DashboardRightSection/DashboardRightSection';
import Cookies from 'js-cookie';
import { submitVote, likeDislike, addComment, getAllComments, addBookmark, deleteComment } from '../../api/Vote';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import CloseIcon from '@mui/icons-material/Close';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import humanizeDuration from 'humanize-duration';
import Snackbar from '@mui/material/Snackbar';
import "./SingleVote.css";
import { getUserId, getToken } from '../../api/index';
import { getHumanizedTime } from '../getHumanizedTime';
import ProfileCompletionPrompt from '../Shared/ProfileCompletionPrompt';
import ShareModal from '../Shared/ShareModal';


const SingleVote = () => {
    const [searchParams] = useSearchParams();
    const voteId = searchParams.get("voteId");
    const userId = getUserId();
    const [vote, setVote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [voteDetails, setVoteDetails] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [filePreviews, setFilePreviews] = useState({});
    const fileInputRef = React.useRef(null);
    const [openComments, setOpenComments] = useState({});
    const [allComments, setAllComments] = useState([]);
    const [commentText, setCommentText] = useState("");
    const [faceRecognitionDialogOpen, setFaceRecognitionDialogOpen] = useState(false);
    const [pendingVote, setPendingVote] = useState(null);
    const [isSignIn, setIsSignIn] = useState(false);
    const [isUserVerified, setIsUserVerified] = useState('');
    const [unmutedVideoId, setUnmutedVideoId] = useState(null);
    const [playingVideos, setPlayingVideos] = useState({});
    const [isReportClicked, setIsReportClicked] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [commentLoader, setCommentLoader] = useState(false);      
    const [profilePromptOpen, setProfilePromptOpen] = useState(false);
    // Adding missing state variables from Feeds.js
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const [selectedVoteForShare, setSelectedVoteForShare] = useState(null);

    // Loading states for different media types
    const [imageLoading, setImageLoading] = useState({});
    const [videoLoading, setVideoLoading] = useState({});
    const [commentMediaLoading, setCommentMediaLoading] = useState({});
    const [previewLoading, setPreviewLoading] = useState({});
    const [profileImageLoading, setProfileImageLoading] = useState({});
    const [commentProfileLoading, setCommentProfileLoading] = useState({});

    // Helper functions for loading states
    const handleImageLoad = (id, type) => {
        if (type === 'main') {
            setImageLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'profile') {
            setProfileImageLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'comment') {
            setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'preview') {
            setPreviewLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'commentProfile') {
            setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
        }
    };

    const handleImageError = (id, type) => {
        if (type === 'main') {
            setImageLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'profile') {
            setProfileImageLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'comment') {
            setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'preview') {
            setPreviewLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'commentProfile') {
            setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
        }
    };

    const handleVideoLoad = (id, type) => {
        if (type === 'main') {
            setVideoLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'comment') {
            setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
        } else if (type === 'preview') {
            setPreviewLoading(prev => ({ ...prev, [id]: false }));
        }
    };

    const setMediaLoading = (id, type, isLoading) => {
        if (type === 'main-image') {
            setImageLoading(prev => ({ ...prev, [id]: isLoading }));
        } else if (type === 'main-video') {
            setVideoLoading(prev => ({ ...prev, [id]: isLoading }));
        } else if (type === 'profile') {
            setProfileImageLoading(prev => ({ ...prev, [id]: isLoading }));
        } else if (type === 'comment') {
            setCommentMediaLoading(prev => ({ ...prev, [id]: isLoading }));
        } else if (type === 'preview') {
            setPreviewLoading(prev => ({ ...prev, [id]: isLoading }));
        } else if (type === 'commentProfile') {
            setCommentProfileLoading(prev => ({ ...prev, [id]: isLoading }));
        }
    };

    useEffect(() => {
        fetchVoteDetails();
    }, [voteId]);

    useEffect(() => {
        const token = getToken();
        const userId = getUserId();
        const getUserDetails = async () => {
            const response = await getUser(userId);
            console.log(" response from getUser api:", response.data);
            if (response.data?.governmentId === null) {
                setIsUserVerified('notUploaded');
            } else if (response.data?.governmentId?.verificationStatus === 'approved') {
                setIsUserVerified('verified');
            } else if (response.data?.governmentId?.verificationStatus === 'rejected') {
                setIsUserVerified('rejected');
            }
            else {
                setIsUserVerified('pending');
            }
        }
        getUserDetails();
    }, []);

    useEffect(() => {
        console.log("isUserVerified", isUserVerified);
    }, [isUserVerified]);

    // Clean up preview URLs when component unmounts
    useEffect(() => {
        return () => {
            // Cleanup all previews
            Object.values(filePreviews).forEach(url => {
                URL.revokeObjectURL(url);
            });
        };
    }, [filePreviews]);

    // Effect to handle body scrolling when popup is open
    useEffect(() => {
        if (showPopup) {
            // Disable scrolling
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to ensure scrolling is re-enabled when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showPopup]);

    const fetchVoteDetails = async () => {
        const credentials = {
            voteId: voteId,
            userId: userId
        }
        console.log("credentials", credentials);
        try {
            const response = await getVoteDetailsById(credentials);
            setVoteDetails(response);
        } catch (error) {
            setError(error);
        }
    }
    console.log("voteDetails", voteDetails);
    const isProfileComplete = () => {
        try {
            const userRaw = localStorage.getItem('userDetails');
            if (!userRaw) return false;
            const u = JSON.parse(userRaw);
            const hasName = !!((u.firstName && u.firstName.trim()) || (u.lastName && u.lastName.trim()) || u.displayName);
            const hasDob = !!u.dateOfBirth;
            const hasAddress = Array.isArray(u.addresses) ? u.addresses.length > 0 : !!u.address;
            return hasName && hasDob && hasAddress;
        } catch {
            return false;
        }
    };

    const guardAnd = () => {
        if (!isProfileComplete()) {
            setProfilePromptOpen(true);
            return false;
        }
        return true;
    };

    const handleSubmitVote = async (voteId, optionId) => {
        if (!guardAnd()) return;
        setPendingVote({ voteId, optionId });
        setFaceRecognitionDialogOpen(true);
    }

    useEffect(() => {
        if (isSignIn && pendingVote) {
            const submit = async () => {
                const userId = getUserId();
                try {
                    const response = await submitVote({ voteId: pendingVote.voteId, userId, optionId: pendingVote.optionId });
                    console.log(" response from submitVote api:", response);
                    setVoteDetails(prevVote => ({
                        ...prevVote,
                        isVoted: true,
                        selectedOptionId: pendingVote.optionId,
                        options: prevVote.options.map(option => ({
                            ...option,
                            voteCount: option.id === pendingVote.optionId ? option.voteCount + 1 : option.voteCount,
                            percentage: calculatePercentage(prevVote.options, option.id, pendingVote.optionId)
                        }))
                    }));
                } catch (error) {
                    console.log("error", error);
                }
                setIsSignIn(false);
                setFaceRecognitionDialogOpen(false);
                setPendingVote(null);
            };
            submit();
        }
    }, [isSignIn, pendingVote]);

    // Helper function to calculate percentage
    const calculatePercentage = (options, currentOptionId, selectedOptionId) => {
        const totalVotes = options.reduce((sum, option) =>
            sum + option.voteCount + (option.id === selectedOptionId ? 1 : 0), 0);
        const currentOptionVotes = options.find(opt => opt.id === currentOptionId).voteCount +
            (currentOptionId === selectedOptionId ? 1 : 0);
        return totalVotes === 0 ? 0 : Math.round((currentOptionVotes / totalVotes) * 100);
    }

    const handleHelpClick = (e, cardId) => {
        e.preventDefault();
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();

        // Get viewport dimensions
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        // Estimate popup dimensions (you can adjust these based on your CSS)
        const popupHeight = 200; // Adjust based on your popup height
        const popupWidth = 250; // Adjust based on your popup width

        // Calculate available space
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const spaceRight = viewportWidth - rect.right;
        const spaceLeft = rect.left;

        // Determine vertical position
        let top;
        if (spaceBelow >= popupHeight) {
            // Position below the button
            top = rect.bottom;
        } else if (spaceAbove >= popupHeight) {
            // Position above the button
            top = rect.top - popupHeight;
        } else {
            // Center vertically if neither space is sufficient
            top = Math.max(0, (viewportHeight - popupHeight) / 2);
        }

        // Determine horizontal position
        let left;
        if (spaceLeft >= popupWidth) {
            // Position to the left of the button (current behavior)
            left = rect.left - popupWidth;
        } else if (spaceRight >= popupWidth) {
            // Position to the right of the button
            left = rect.right;
        } else {
            // Center horizontally if neither space is sufficient
            left = Math.max(0, (viewportWidth - popupWidth) / 2);
        }

        setPopupPosition({
            top: top,
            left: left
        });
        setSelectedCardId(cardId);
        setShowPopup(true);
        setIsReportClicked(false);
    };


    const handleLikeDislike = async (voteId) => {
        if (!guardAnd()) return;
        const userId = getUserId();
        try {
            const response = await likeDislike({ voteId, userId });
            console.log(" response from likeDislike api:", response);
            setVoteDetails(prevVote => ({
                ...prevVote,
                isLiked: !prevVote.isLiked,
                likeCount: prevVote.isLiked ? prevVote.likeCount - 1 : prevVote.likeCount + 1
            }));
        } catch (error) {
            console.log("error", error);
        }
    }

    const handleCommentLikeDislike = async (voteId, commentId, action) => {
        const comment = allComments.find(c => c.commentId === commentId);
        if (!comment) return;

        if (action === 'up' && comment.isLiked) return;
        if (action === 'down' && !comment.isLiked) return;

        if (!guardAnd()) return;
        const userId = getUserId();
        
        try {
            const response = await likeDislike({ voteId, userId, targetId: commentId, targetType: 1 });
            console.log(" response from comment likeDislike api:", response);
            setAllComments(prevComments => {
                let updated = prevComments.map(c => {
                    if (c.commentId === commentId) {
                        return {
                            ...c,
                            isLiked: !c.isLiked,
                            likeCount: c.isLiked ? Math.max(0, c.likeCount - 1) : c.likeCount + 1
                        };
                    }
                    return c;
                });
                return updated.sort((a, b) => b.likeCount - a.likeCount);
            });
        } catch (error) {
            console.log("error", error);
        }
    };


    const handleCommentIconClick = async (voteId, commentCount) => {
        // Close all other open comments except the one being toggled
        setOpenComments(prev => {
            const newState = {};
            // If we're opening this comment section, close all others and open this one
            if (!prev[voteId]) {
                newState[voteId] = true;
            }
            // If we're closing this comment section, just close it
            return newState;
        });

        // Clear any existing file previews and selections
        setSelectedFiles({});
        setFilePreviews(prev => {
            // Cleanup existing preview URLs
            Object.values(prev).forEach(url => {
                URL.revokeObjectURL(url);
            });
            return {};
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        // Clear comments when closing
        if (openComments[voteId]) {
            setAllComments([]);
            return;
        }

        // Fetch comments when opening and there are comments
        if (commentCount > 0) {
            try {
                const response = await getAllComments(voteId);
                console.log(" response from getAllComments api:", response);
                const sortedComments = [...(response.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
                setAllComments(sortedComments);
            } catch (error) {
                console.log("error", error);
            }
        }
    };

    const handleCommentSubmit = async (voteId) => {
        if (!guardAnd()) return;
        if (commentLoader) return;
        setCommentLoader(true);
        console.log("commentText", commentText);
        console.log("voteId", voteId);
        const userId = getUserId();
        try {
            const formData = new FormData();
            formData.append("voteId", voteId);
            formData.append("userId", userId);

            if (commentText.length > 0) {
                formData.append("commentText", commentText);
            } else if (selectedFiles[voteId]) {
                const file = selectedFiles[voteId];
                console.log("File being sent:", file);
                formData.append("Video", file);
            }
            const response = await addComment(formData);
            console.log(" response from addComment api:", response);

            // Clear the input after successful submission
            setCommentText("");
            if (selectedFiles[voteId]) {
                clearFileSelection(voteId);
            }

            // Update UI
            setVoteDetails(prevVote => ({
                ...prevVote,
                commentCount: prevVote.commentCount + 1
            }));

            // Refresh comments
            const commentsResponse = await getAllComments(voteId);
            const sortedComments = [...(commentsResponse.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
            setAllComments(sortedComments);
        } catch (error) {
            console.log("error", error);
        } finally {
            setCommentLoader(false);
        }
    };

    const clearFileSelection = (voteId) => {
        // Clear the specific file and preview
        setSelectedFiles(prev => {
            const newFiles = { ...prev };
            delete newFiles[voteId];
            return newFiles;
        });

        setFilePreviews(prev => {
            const newPreviews = { ...prev };
            if (newPreviews[voteId]) {
                URL.revokeObjectURL(newPreviews[voteId]);
                delete newPreviews[voteId];
            }
            return newPreviews;
        });

        // Reset the file input value
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleClickOutside = (e) => {
        if (e.target.className === 'popupOverlay') {
            setShowPopup(false);
        }
    };

    const handleSave = async (voteId) => {
        console.log('Saving card:', voteId);
        setShowPopup(false);
        const userId = getUserId();
        try {
            const response = await addBookmark({ voteId, userId });
            console.log(" response from addBookmark api:", response);
            setSnackbarMessage("Saved successfully");
            setSnackbarOpen(true);
        } catch (error) {
            console.log("error", error);
            setSnackbarMessage("Failed to save. Please try again.");
            setSnackbarOpen(true);
        }
    };

    const handleReport = () => {
        setIsReportClicked(!isReportClicked);
    };

    const handleReportOption = (option) => {
        setShowPopup(false);
    };

    const handleVolumeToggle = (voteId, event) => {
        event.stopPropagation();
        setUnmutedVideoId(unmutedVideoId === voteId ? null : voteId);
    };

    const handleVideoPlayPause = (voteId, event) => {
        event.stopPropagation();
        const videoElement = event.target.closest('.voteMediaContainer').querySelector('video');

        if (videoElement) {
            if (playingVideos[voteId]) {
                videoElement.pause();
                setPlayingVideos(prev => ({ ...prev, [voteId]: false }));
            } else {
                videoElement.play();
                setPlayingVideos(prev => ({ ...prev, [voteId]: true }));
            }
        }
    };

    const handleFileSelect = (e, voteId) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({
                ...prev,
                [voteId]: file
            }));

            // Create preview URL
            const previewUrl = URL.createObjectURL(file);
            setFilePreviews(prev => ({
                ...prev,
                [voteId]: previewUrl
            }));

            // Clear text if there was any
            setCommentText("");
        }
    };

    const handlePlusClick = () => {
        fileInputRef.current?.click();
    };

    const handleDeleteComment = async (commentId, voteId) => {
        const userId = Cookies.get("userId");
        try {
            const response = await deleteComment({ commentId, userId });
            console.log(" response from deleteComment api:", response);

            if (response) {
                // Update UI by removing the deleted comment
                setAllComments(prevComments =>
                    prevComments.filter(comment => comment.commentId !== commentId)
                );

                // Update the comment count in the vote details
                setVoteDetails(prevVote => ({
                    ...prevVote,
                    commentCount: prevVote.commentCount - 1
                }));
            } else {
                throw new Error('Failed to delete comment');
            }

        } catch (error) {
            console.error("Error deleting comment:", error);
        }
    };

    const handleFaceRecognitionSuccess = () => {
        setIsSignIn(true);
    };

    // Adding share functionality from Feeds.js
    const handleShare = async (vote) => {
        setSelectedVoteForShare(vote);
        setShareDialogOpen(true);
    };

    const handleSystemShare = async () => {
        const shareUrl = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
        const shareData = {
            title: 'Share Vote',
            text: selectedVoteForShare.title,
            url: shareUrl,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
        setShareDialogOpen(false);
    };

    const handleCopyLink = () => {
        const shareUrl = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
        navigator.clipboard.writeText(shareUrl).then(() => {
            setSnackbarMessage('Link copied to clipboard!');
            setSnackbarOpen(true);
            setShareDialogOpen(false);
        });
    };

    // Helper function to get user initials
    const getUserInitials = (userName) => {
        if (!userName) return '';
        const words = userName.trim().split(' ');
        if (words.length === 1) {
            return words[0].charAt(0).toUpperCase();
        }
        const firstInitial = words[0] ? words[0].charAt(0).toUpperCase() : '';
        const lastInitial = words[words.length - 1] ? words[words.length - 1].charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial;
    };

    // Helper function to generate background color based on initials
    const getBackgroundColor = (initials) => {
        const colors = [
            '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
            '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
            '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
        ];

        let hash = 0;
        for (let i = 0; i < initials.length; i++) {
            hash = initials.charCodeAt(i) + ((hash << 5) - hash);
        }
        hash = Math.abs(hash);
        return colors[hash % colors.length];
    };


    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        {voteDetails && (
                            <div className="Feeds" style={{ marginBottom: '30px' }}>
                                <div className="feedsContainer">
                                    <div className="feedCardContainer">
                                        <div className="feedCard">
                                            <div className="feedBody">
                                                <div className="feedCardHeader">
                                                    <div className="profileDetailsContainer">
                                                        {voteDetails.createdByUserPhoto ? (
                                                            <div style={{ position: 'relative' }}>
                                                                {profileImageLoading[voteDetails.voteId] && (
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform: 'translate(-50%, -50%)',
                                                                        zIndex: 2
                                                                    }}>
                                                                        <CircularProgress size={20} sx={{ color: '#5AAF9A' }} />
                                                                    </div>
                                                                )}
                                                                <img
                                                                    src={voteDetails.createdByUserPhoto}
                                                                    alt="no-img-found"
                                                                    className="profilePic"
                                                                    onLoad={() => handleImageLoad(voteDetails.voteId, 'profile')}
                                                                    onError={() => handleImageError(voteDetails.voteId, 'profile')}
                                                                    onLoadStart={() => setMediaLoading(voteDetails.voteId, 'profile', true)}
                                                                    style={{
                                                                        opacity: profileImageLoading[voteDetails.voteId] ? 0.3 : 1,
                                                                        transition: 'opacity 0.3s ease'
                                                                    }}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="profilePic"
                                                                style={{
                                                                    backgroundColor: getBackgroundColor(getUserInitials(voteDetails.displayName)),
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '16px',
                                                                    fontFamily: 'Arial, sans-serif'
                                                                }}
                                                            >
                                                                {getUserInitials(voteDetails.displayName)}
                                                            </div>
                                                        )}
                                                        <div className="profileDetails">
                                                            <span className="profileNameText">{voteDetails.displayName ? voteDetails.displayName : voteDetails.createdByUserName}</span>
                                                        </div>
                                                    </div>
                                                    <div className="timeContainer">
                                                        {voteDetails.isPaused ? <div className="pausedContainer"><span className="pausedtext">Paused</span></div> : <div className="timeContainer"><span className="timeText">{getHumanizedTime(voteDetails.createdOn)}</span></div>}
                                                        <img
                                                            src="/Assets/Sidebar/helpCenterIcon.svg"
                                                            alt="no img found"
                                                            className="infoIcon"
                                                            onClick={(e) => handleHelpClick(e, voteDetails.voteId)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="feedCardVoteTitleContainer">
                                                    <span className="voteTitleText">
                                                        {voteDetails.title}
                                                    </span>
                                                </div>
                                                {voteDetails?.imageUrls?.[0] && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                                                    {imageLoading[voteDetails.voteId] && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 2,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                                                        </div>
                                                    )}
                                                    {voteDetails?.imageUrls?.[0] && <img
                                                        src={voteDetails?.imageUrls?.[0] || "/Sidebar/voteImage.svg"}
                                                        alt="no-img-found"
                                                        className="voteMedia"
                                                        onLoad={() => handleImageLoad(voteDetails.voteId, 'main')}
                                                        onError={() => handleImageError(voteDetails.voteId, 'main')}
                                                        onLoadStart={() => setMediaLoading(voteDetails.voteId, 'main-image', true)}
                                                        style={{
                                                            opacity: imageLoading[voteDetails.voteId] ? 0.3 : 1,
                                                            transition: 'opacity 0.3s ease'
                                                        }}
                                                    />}
                                                </div>}
                                                {voteDetails?.videoUrl && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                                                    {videoLoading[voteDetails.voteId] && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 2,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                                                        </div>
                                                    )}
                                                    <video
                                                        src={voteDetails?.videoUrl}
                                                        alt="no-video-found"
                                                        className="voteMedia"
                                                        muted={unmutedVideoId !== voteDetails.voteId}
                                                        loop
                                                        onPlay={() => setPlayingVideos(prev => ({ ...prev, [voteDetails.voteId]: true }))}
                                                        onPause={() => setPlayingVideos(prev => ({ ...prev, [voteDetails.voteId]: false }))}
                                                        onLoadStart={() => setMediaLoading(voteDetails.voteId, 'main-video', true)}
                                                        onLoadedData={() => handleVideoLoad(voteDetails.voteId, 'main')}
                                                        onError={() => setVideoLoading(prev => ({ ...prev, [voteDetails.voteId]: false }))}
                                                        onClick={(e) => handleVideoPlayPause(voteDetails.voteId, e)}
                                                        style={{
                                                            cursor: "pointer",
                                                            opacity: videoLoading[voteDetails.voteId] ? 0.3 : 1,
                                                            transition: 'opacity 0.3s ease'
                                                        }}
                                                    />

                                                    {/* Play/Pause Button Overlay */}
                                                    {!playingVideos[voteDetails.voteId] && !videoLoading[voteDetails.voteId] && (
                                                        <div
                                                            className="playPauseOverlay"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                cursor: 'pointer',
                                                                zIndex: 10
                                                            }}
                                                            onClick={(e) => handleVideoPlayPause(voteDetails.voteId, e)}
                                                        >
                                                            <PlayArrowRoundedIcon
                                                                sx={{
                                                                    color: "#5AAF9A",
                                                                    fontSize: { xs: "50px", sm: "50px", md: "50px", lg: "70px" },
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    <div className="volumeControlContainer" style={{
                                                        position: 'absolute',
                                                        top: '10px',
                                                        right: '10px',
                                                        background: 'rgba(0, 0, 0, 0.5)',
                                                        borderRadius: '50%',
                                                        padding: '4px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        opacity: videoLoading[voteDetails.voteId] ? 0.3 : 1,
                                                        transition: 'opacity 0.3s ease'
                                                    }}
                                                        onClick={(e) => handleVolumeToggle(voteDetails.voteId, e)}
                                                    >
                                                        {unmutedVideoId === voteDetails.voteId ? (
                                                            <VolumeUpIcon
                                                                sx={{
                                                                    color: "#fff",
                                                                    fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                                                                    cursor: "pointer",
                                                                    "&:hover": { opacity: 0.8 }
                                                                }}
                                                            />
                                                        ) : (
                                                            <VolumeOffIcon
                                                                sx={{
                                                                    color: "#fff",
                                                                    fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                                                                    cursor: "pointer",
                                                                    "&:hover": { opacity: 0.8 }
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>}
                                                {
                                                    voteDetails?.fileUrl && voteDetails.fileUrl.endsWith('.pdf') && (
                                                        <div className="pdfLinkContainer">
                                                            <a
                                                                href={`https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(voteDetails.fileUrl)}&embedded=true`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="pdfLink"
                                                            >
                                                                <PictureAsPdfRoundedIcon sx={{ color: "black", fontSize: { xs: "15px", sm: "20px", md: "20px", lg: "25px" } }} />
                                                                View PDF
                                                            </a>
                                                        </div>
                                                    )
                                                }

                                                <div className="voteDescriptionContainer">
                                                    <span className="voteDescriptionText">{voteDetails.description}</span>
                                                </div>

                                                <div className="voteBtnsContainer">
                                                    {voteDetails.options.map((option) => (
                                                        <button
                                                            key={option.id}
                                                            className={`vote-button-wrapper ${voteDetails.isVoted ? 'voted' : ''} ${option.isSelected ? 'selected' : ''}`}
                                                            onClick={() => !voteDetails.isVoted && handleSubmitVote(voteDetails.voteId, option.id)}
                                                            disabled={voteDetails.isVoted || voteDetails.isPaused}
                                                        >
                                                            {voteDetails.isVoted && (
                                                                <div
                                                                    className="vote-progress-bar"
                                                                    style={{ width: `${option.percentage}%` }}
                                                                />
                                                            )}
                                                            <span className="vote-text">{option.value}</span>
                                                            {voteDetails.isVoted && (
                                                                <span className="vote-percentage">{option.percentage}%</span>
                                                            )}
                                                        </button>
                                                    ))}
                                                </div>
                                                <div className="voteDetailsContainer">
                                                    <div className="voteActionContainer">
                                                        <div className={`voteActionContainer2 ${voteDetails.isLiked ? 'liked' : ''}`} onClick={() => handleLikeDislike(voteDetails.voteId)}>
                                                            {voteDetails.isLiked ? (
                                                                <FavoriteRoundedIcon sx={{ color: "#FF0000", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                            ) : (
                                                                <FavoriteBorderRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                            )}
                                                            <span className={`feedCardFooterText ${voteDetails.isLiked ? 'liked-text' : ''}`}>{voteDetails.likeCount}</span>
                                                        </div>
                                                        <div className="voteActionContainer2" onClick={() => handleCommentIconClick(voteDetails.voteId, voteDetails.commentCount)}>
                                                            <ChatBubbleOutlineRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                            <span className="feedCardFooterText">{voteDetails.commentCount}</span>
                                                        </div>
                                                    </div>
                                                    <div className="voteShareContainer">
                                                        <NearMeOutlinedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} onClick={() => handleShare(voteDetails)} />
                                                    </div>
                                                </div>
                                                {openComments[voteDetails.voteId] && (
                                                    <div className="commentContainer">
                                                        <div className="commentInputContainer">
                                                            <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={(e) => handleFileSelect(e, voteDetails.voteId)}
                                                                accept="image/*,video/*"
                                                                className="feedsCommentInput"
                                                            />
                                                            {filePreviews[voteDetails.voteId] ? (
                                                                <div className="filePreviewContainer" style={{ position: 'relative' }}>
                                                                    {previewLoading[voteDetails.voteId] && (
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            zIndex: 2,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}>
                                                                            <CircularProgress size={30} sx={{ color: '#5AAF9A' }} />
                                                                        </div>
                                                                    )}
                                                                    {selectedFiles[voteDetails.voteId]?.type.startsWith('image/') ? (
                                                                        <img
                                                                            src={filePreviews[voteDetails.voteId]}
                                                                            alt="Selected"
                                                                            className="filePreview"
                                                                            onLoad={() => handleImageLoad(voteDetails.voteId, 'preview')}
                                                                            onError={() => handleImageError(voteDetails.voteId, 'preview')}
                                                                            onLoadStart={() => setMediaLoading(voteDetails.voteId, 'preview', true)}
                                                                            style={{
                                                                                opacity: previewLoading[voteDetails.voteId] ? 0.3 : 1,
                                                                                transition: 'opacity 0.3s ease'
                                                                            }}
                                                                        />
                                                                    ) : selectedFiles[voteDetails.voteId]?.type.startsWith('video/') ? (
                                                                        <video
                                                                            src={filePreviews[voteDetails.voteId]}
                                                                            className="filePreview"
                                                                            muted
                                                                            autoPlay
                                                                            loop
                                                                            onLoadStart={() => setMediaLoading(voteDetails.voteId, 'preview', true)}
                                                                            onLoadedData={() => handleVideoLoad(voteDetails.voteId, 'preview')}
                                                                            onError={() => setPreviewLoading(prev => ({ ...prev, [voteDetails.voteId]: false }))}
                                                                            style={{
                                                                                opacity: previewLoading[voteDetails.voteId] ? 0.3 : 1,
                                                                                transition: 'opacity 0.3s ease'
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                </div>
                                                            ) : (
                                                                <textarea
                                                                    placeholder="Add a comment..."
                                                                    className="feedsCommentInput"
                                                                    value={commentText}
                                                                    onChange={(e) => setCommentText(e.target.value)}
                                                                />
                                                            )}
                                                            <div className="commentButtonContainer">
                                                                <button
                                                                    className="commentButton"
                                                                    onClick={() => filePreviews[voteDetails.voteId] ? clearFileSelection(voteDetails.voteId) : handlePlusClick()}
                                                                >
                                                                    {filePreviews[voteDetails.voteId] ? (
                                                                        <CloseRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                                    ) : (
                                                                        <AddRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                                    )}
                                                                </button>
                                                                <button className="commentButton" onClick={() => handleCommentSubmit(voteDetails.voteId)}>
                                                                    <SendRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="existingCommentsContainer">
                                                            {allComments.length > 0 && allComments.map((comment) => (
                                                                <div key={comment.commentId} className="commentItem">
                                                                    <div className="commentItemContainer">
                                                                        <div className="commentHeader">
                                                                            {comment.userPhoto ? (
                                                                                <div style={{ position: 'relative' }}>
                                                                                    {commentProfileLoading[comment.commentId] && (
                                                                                        <div style={{
                                                                                            position: 'absolute',
                                                                                            top: '50%',
                                                                                            left: '50%',
                                                                                            transform: 'translate(-50%, -50%)',
                                                                                            zIndex: 2
                                                                                        }}>
                                                                                            <CircularProgress size={15} sx={{ color: '#5AAF9A' }} />
                                                                                        </div>
                                                                                    )}
                                                                                    <img
                                                                                        src={comment.userPhoto}
                                                                                        alt={comment.userName}
                                                                                        className="commentUserPhoto"
                                                                                        onLoad={() => handleImageLoad(comment.commentId, 'commentProfile')}
                                                                                        onError={() => handleImageError(comment.commentId, 'commentProfile')}
                                                                                        onLoadStart={() => setMediaLoading(comment.commentId, 'commentProfile', true)}
                                                                                        style={{
                                                                                            opacity: commentProfileLoading[comment.commentId] ? 0.3 : 1,
                                                                                            transition: 'opacity 0.3s ease'
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div
                                                                                    className="commentUserPhoto"
                                                                                    style={{
                                                                                        backgroundColor: getBackgroundColor(getUserInitials(comment.userName)),
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        color: 'white',
                                                                                        fontWeight: 'bold',
                                                                                        fontSize: '14px',
                                                                                        fontFamily: 'Arial, sans-serif'
                                                                                    }}
                                                                                >
                                                                                    {getUserInitials(comment?.userName)}
                                                                                </div>
                                                                            )}
                                                                            <div className="commentUserInfo">
                                                                                <span className="commentUserName">{comment.userName}</span>
                                                                                <span className="commentTime">
                                                                                    {getHumanizedTime(comment?.createdAt)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        {comment?.videoUrl && (
                                                                            <div className="commentVideoContainer" style={{ position: 'relative' }}>
                                                                                {commentMediaLoading[comment.commentId] && (
                                                                                    <div style={{
                                                                                        position: 'absolute',
                                                                                        top: '50%',
                                                                                        left: '50%',
                                                                                        transform: 'translate(-50%, -50%)',
                                                                                        zIndex: 2,
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>
                                                                                        <CircularProgress size={25} sx={{ color: '#5AAF9A' }} />
                                                                                    </div>
                                                                                )}
                                                                                {comment?.videoUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
                                                                                    <video
                                                                                        src={comment?.videoUrl}
                                                                                        className="commentVideo"
                                                                                        muted
                                                                                        autoPlay
                                                                                        loop
                                                                                        onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                                                                        onLoadedData={() => handleVideoLoad(comment.commentId, 'comment')}
                                                                                        onError={() => setCommentMediaLoading(prev => ({ ...prev, [comment.commentId]: false }))}
                                                                                        style={{
                                                                                            opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                                                                            transition: 'opacity 0.3s ease'
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <img
                                                                                        src={comment?.videoUrl}
                                                                                        alt="comment media"
                                                                                        className="commentVideo"
                                                                                        onLoad={() => handleImageLoad(comment.commentId, 'comment')}
                                                                                        onError={() => handleImageError(comment.commentId, 'comment')}
                                                                                        onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                                                                        style={{
                                                                                            opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                                                                            transition: 'opacity 0.3s ease'
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {comment?.commentText?.trim() && <div className="commentText">
                                                                            {comment?.commentText.trim()}
                                                                        </div>}
                                                                        <div className="commentActionsRow" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', background: '#2a2a2a', borderRadius: '12px', padding: '2px' }}>
                                                                                <KeyboardArrowUpRoundedIcon 
                                                                                    sx={{ 
                                                                                        color: comment.isLiked ? "#5AAF9A" : "#808080", 
                                                                                        fontSize: "20px", 
                                                                                        cursor: comment.isLiked ? "default" : "pointer",
                                                                                        "&:hover": { color: comment.isLiked ? "#5AAF9A" : "#ffffff" }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleCommentLikeDislike(comment.voteId, comment.commentId, 'up');
                                                                                    }}
                                                                                />
                                                                                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#fff', margin: '0 4px', minWidth: '12px', textAlign: 'center' }}>
                                                                                    {comment.likeCount || 0}
                                                                                </span>
                                                                                <KeyboardArrowDownRoundedIcon 
                                                                                    sx={{ 
                                                                                        color: !comment.isLiked ? "#808080" : "#808080",
                                                                                        fontSize: "20px", 
                                                                                        cursor: !comment.isLiked ? "default" : "pointer",
                                                                                        "&:hover": { color: !comment.isLiked ? "#808080" : "#ffffff" }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleCommentLikeDislike(comment.voteId, comment.commentId, 'down');
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {comment?.userId === userId && (
                                                                        <div className="commentItemContainer">
                                                                            <button
                                                                                className="deleteCommentBtn"
                                                                                onClick={() => handleDeleteComment(comment.commentId, comment.voteId)}
                                                                            >
                                                                                <DeleteOutlineIcon sx={{ color: "#C15F5F", fontSize: "20px", cursor: "pointer" }} />
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {showPopup && (
                                    <div className="popupOverlay" onClick={handleClickOutside}>
                                        <div
                                            className="popupContent"
                                            style={{
                                                top: `${popupPosition.top}px`,
                                                left: `${popupPosition.left}px`
                                            }}
                                        >
                                            <span className="popupTitle">Information</span>
                                            <button className="popupBtn saveBtn" onClick={() => handleSave(selectedCardId)}>
                                                <img src="/Assets/Sidebar/saveIcon.svg" alt="no-img-found" className="informationBtnIcon" />
                                                <span className="informationBtnText">Save</span>
                                            </button>
                                            <button className="popupBtn reportBtn" onClick={handleReport}>
                                                <img src="/Assets/Sidebar/reportIcon.svg" alt="no-img-found" className="informationBtnIcon" />
                                                <span className="reportBtnText">Report this content</span>
                                            </button>
                                            {isReportClicked && <div className="reportReasonContainer">
                                                <span className="informationBtnText">Select a reason</span>
                                                <div className="reportReasonOptions">
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Harmful or Dangerous Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Harrasment or Hate Speech</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Sexual or Inappropriate Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Spam or misleading</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Violent or Graphic Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Other</span>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        <Dialog
                            open={faceRecognitionDialogOpen}
                            onClose={() => setFaceRecognitionDialogOpen(false)}
                            maxWidth="md"
                            fullWidth
                            PaperProps={{
                                sx: {
                                    width: '150%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    marginTop: '150px',
                                    backgroundColor: '#0e1b1b',
                                    position: 'relative',
                                }
                            }}
                        >
                            <DialogTitle sx={{ color: 'white', width: '100%', pr: 5, pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                Verify your identity
                                <CloseIcon
                                    onClick={() => setFaceRecognitionDialogOpen(false)}
                                    sx={{
                                        position: 'absolute',
                                        right: 16,
                                        top: 16,
                                        color: 'white',
                                        cursor: 'pointer',
                                        fontSize: 28,
                                        zIndex: 10,
                                    }}
                                    aria-label="close"
                                />
                            </DialogTitle>
                            <FaceRecognition 
                              isUserVerified={isUserVerified} 
                              onSuccess={handleFaceRecognitionSuccess}
                              onCancel={() => setFaceRecognitionDialogOpen(false)}
                            />
                        </Dialog>
        <ProfileCompletionPrompt
            open={profilePromptOpen}
            onClose={() => setProfilePromptOpen(false)}
            message={"Please complete your profile (name, date of birth, and address) to continue."}
        />
                        <ShareModal
                            open={shareDialogOpen}
                            onClose={() => setShareDialogOpen(false)}
                            item={selectedVoteForShare || voteDetails}
                            shareType="ballot"
                            onToast={(msg) => {
                                setSnackbarMessage(msg);
                                setSnackbarOpen(true);
                            }}
                        />

                        {/* Snackbar for feedback */}
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={3000}
                            onClose={() => setSnackbarOpen(false)}
                            message={snackbarMessage}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        />
                    </div>

                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SingleVote;